import commonRoutes from './main/common'
import intelligentOfficialDoc from '@views/intelligentOfficialDoc/route'
import adminBankLive from './micro/admin-bank-live'
import home from './main/home'

// 默认主题路由
export { default as defaultRoutes} from './themes/default'
// 横向主题路由
export { default as horizontalRoutes} from './themes/horizontal'
// 子路由部分公共
export const customRoute = { '/home': home }

export default [
  ...intelligentOfficialDoc,
  ...adminBankLive,
  ...commonRoutes,
]
